import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminUserDetail from "./AdminUserDetail";
import AdminPostManagement from "./AdminPostManagement";
import AdminAutoPostSettings from "./AdminAutoPostSettings";

const AdminUserDetailPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [view, setView] = useState("detail"); // "detail" | "posts" | "autoSettings"

  if (view === "posts") {
    return (
      <div>
        <div className="p-4 pb-0">
          <button
            onClick={() => setView("detail")}
            className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors mb-3"
          >
            ← Quay lại chi tiết
          </button>
        </div>
        <AdminPostManagement userId={userId} />
      </div>
    );
  }

  if (view === "autoSettings") {
    return (
      <AdminAutoPostSettings
        userId={userId}
        onBack={() => setView("detail")}
      />
    );
  }

  return (
    <div className="p-4 md:p-6">
      <AdminUserDetail
        userId={userId}
        onBack={() => navigate("/admin/users")}
        onViewPosts={() => setView("posts")}
        onViewAutoSettings={() => setView("autoSettings")}
      />
    </div>
  );
};

export default AdminUserDetailPage;
